import styled, { css } from 'styled-components'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Text from 'components/common/Text/Text'

export const Headline = styled(Text)`
  ${Media.mobile`
    font-size: 30px;
    line-height: 30px;
  `}
  ${Mixin.responsive('margin-bottom', '32px', '30px')}
  ${props => props.link && css`
    ${Media.mobile`
      margin-bottom: 7px;
    `}
  `}
`

export const Title = styled.h1`
  margin: 0 0 25px;
  color: ${Theme.colors.black_new};
  text-align: center;
  text-transform: uppercase;
  transform: scale(1, 1.5);
  ${Mixin.font.GothamBold(34)}
  ${Media.mobile`
    font-size: 22px;
  `}
`

export const SubHead = styled.div`
  color: ${Theme.colors.black_new};
  text-align: center;
  ${Mixin.font.GothamBook(20, 400, 28)}
  ${Media.mobile`
    font-size: 16px;
    line-height: 22px;
  `}
`

export const ServiceWrapper = styled.div`
  ${props => props.centered && css`
    text-align: center;
  `}
`

export const Content = styled.p`
  margin: 0 0 20px;
  overflow: hidden;
  line-height: 22px;
`
